import { createContext } from 'react';

export const GetSpaceContext = createContext();